module.exports = __webpack_public_path__ + "assets/img/schiff.bc53a332.png";